module.exports = __webpack_public_path__ + "img/10112.8c007b16.jpg";